import { apiV1Endpoint } from "../../../../../api/v1";
import axios from "../../../../../utils/axiosInceptor";

export type ChangeStatusRequest = {
  ticketId: string;
  ticketStatus: string;
};

export const changeServiceRequestStatus = async (body: ChangeStatusRequest) => {
  const url = `${apiV1Endpoint}/general-services/service-requests/change-status`;
  const response = await axios.post(url, body);
  return response.data;
};
